import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.cleanbag');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-cleanbag',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.cleanbag/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.cleanbag-page {
  position: relative;
  isolation: isolate;
  min-height: 100svh;
  overflow: hidden;
  background: linear-gradient(155deg, #f0fdfa 0%, #ecfeff 48%, #f7fee7 100%);
}

.clean-wave {
  position: absolute;
  z-index: -2;
  right: -260px;
  bottom: -420px;
  width: 900px;
  height: 900px;
  border: 1px solid rgba(13, 148, 136, 0.1);
  border-radius: 45% 55% 54% 46%;
  background: rgba(45, 212, 191, 0.08);
  transform: rotate(18deg);
}

.clean-bubbles span {
  position: absolute;
  z-index: -1;
  border: 1px solid rgba(20, 184, 166, 0.16);
  border-radius: 9999px;
}

.clean-bubbles span:nth-child(1) {
  top: 18%;
  right: 12%;
  width: 24px;
  height: 24px;
}

.clean-bubbles span:nth-child(2) {
  top: 29%;
  right: 32%;
  width: 12px;
  height: 12px;
}

.clean-bubbles span:nth-child(3) {
  right: 8%;
  bottom: 22%;
  width: 38px;
  height: 38px;
}

.clean-mark {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: #0f766e;
  border: 1px solid rgba(13, 148, 136, 0.18);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 8px 28px rgba(13, 148, 136, 0.08);
}

.clean-status {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #14b8a6;
  animation: clean-pulse 2.2s ease-out infinite;
}

.bag-stage {
  filter: drop-shadow(0 28px 45px rgba(13, 148, 136, 0.12));
}

.bag-halo {
  position: absolute;
  inset: 10%;
  border: 1px dashed rgba(13, 148, 136, 0.2);
  border-radius: 9999px;
  animation: clean-spin 28s linear infinite;
}

.bag-shape {
  position: relative;
  width: 176px;
  height: 205px;
  border: 1px solid rgba(13, 148, 136, 0.22);
  border-radius: 28px 28px 42px 42px;
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.92), rgba(204, 251, 241, 0.74));
  box-shadow: 0 30px 70px rgba(15, 118, 110, 0.14), inset 0 1px 0 white;
}

.bag-handle {
  position: absolute;
  top: -45px;
  left: 46px;
  width: 82px;
  height: 66px;
  border: 12px solid rgba(94, 234, 212, 0.72);
  border-bottom: 0;
  border-radius: 48px 48px 0 0;
}

.bag-shine {
  position: absolute;
  top: 28px;
  right: 27px;
  width: 24px;
  height: 72px;
  border-radius: 9999px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), transparent);
  transform: rotate(-12deg);
}

.leaf {
  position: absolute;
  top: 77px;
  left: 52px;
  width: 72px;
  height: 55px;
  border-radius: 70% 5% 70% 5%;
  background: #14b8a6;
  transform: rotate(-14deg);
}

.leaf span:nth-child(1) {
  position: absolute;
  top: 28px;
  left: 8px;
  width: 60px;
  height: 2px;
  background: rgba(255, 255, 255, 0.7);
  transform: rotate(-30deg);
}

.sparkle {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #2dd4bf;
  box-shadow: 0 0 18px rgba(45, 212, 191, 0.55);
  animation: clean-float 3s ease-in-out infinite;
}

.sparkle-one {
  top: 18%;
  left: 13%;
}

.sparkle-two {
  top: 31%;
  right: 10%;
  animation-delay: -1s;
}

.sparkle-three {
  bottom: 18%;
  right: 20%;
  animation-delay: -2s;
}

@keyframes clean-pulse {
  70% {
    box-shadow: 0 0 0 9px rgba(20, 184, 166, 0);
  }
}
@keyframes clean-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes clean-float {
  50% {
    transform: translateY(-8px);
    opacity: 0.45;
  }
}
@media (prefers-reduced-motion: reduce) {
  .clean-status, .bag-halo, .sparkle {
    animation: none;
  }
}`],
})
export class PageCleanbagComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public navigateHome(event?: MouseEvent) {
        if (!event || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
            return;
        }

        event.preventDefault();
        this.service.href('/');
    }
}

export default PageCleanbagComponent;